module.exports = __webpack_public_path__ + "img/jt.b20b6140.svg";